module.exports = __webpack_public_path__ + "wifi-disabled.png";